var _classCallCheck = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/inherits");

var Gateway = require('./Gateway');

var InjectedGateway =
/*#__PURE__*/
function (_Gateway) {
  "use strict";

  _inherits(InjectedGateway, _Gateway);

  function InjectedGateway() {
    _classCallCheck(this, InjectedGateway);

    return _possibleConstructorReturn(this, _getPrototypeOf(InjectedGateway).apply(this, arguments));
  }

  _createClass(InjectedGateway, [{
    key: "isAvailable",
    value: function isAvailable() {
      return !!window.ethereum || !!(window.web3 && window.web3.currentProvider);
    }
  }, {
    key: "getNetworks",
    value: function getNetworks() {
      return [this._provider().networkVersion];
    }
  }, {
    key: "_provider",
    value: function _provider() {
      return window.ethereum || window.web3.currentProvider;
    }
  }, {
    key: "send",
    value: function send(network, payload) {
      var _this = this;

      if (network !== this._provider().networkVersion) {
        throw new Error('This Gateway does not support the provided network');
      }

      return new Promise(function (resolve, reject) {
        return _this._provider().sendAsync(payload, function (err, _ref) {
          var result = _ref.result,
              error = _ref.error;
          return err || error ? reject(err || error) : resolve(result);
        });
      });
    }
  }]);

  return InjectedGateway;
}(Gateway);

module.exports = InjectedGateway;